var map = {
	"./HK/banner.png": "cgYc",
	"./MY-DIGI/banner.png": "74iY",
	"./MY/banner.png": "kynt",
	"./PH/banner.png": "1kkw",
	"./TW/banner.png": "+6Gu"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pdMw";